import React from 'react'
import { Button, Spinner } from 'react-bootstrap';
const KonfirmasiBatalBid = ({ onCancel, onSubmit, isCancelProcess }) => {
  return (
    <>
      <div className="com-modal-bg"></div>
      <div className='com-modal d-flex flex-center'>
        <div className='com-modal-dialog'>
          <div className='com-modal-content d-flex flex-column' style={{ padding: '16px', gap: '16px' }}>
            <div style={{ fontSize: '20px' }} className='fw-semibold'>Cancel Penawaran</div>
            <p className='text-secondary mb-0'>Apakah anda yakin melakukan cancel penawaran</p>
            <div className='d-flex justify-content-end w-100' style={{ gap: '16px' }}>
              <Button className='btn-upload' onClick={onCancel} disabled={isCancelProcess}>Batal</Button>
              <Button className="filter-button fw-semibold" onClick={onSubmit} disabled={isCancelProcess}>
                {isCancelProcess ? <Spinner animation="border" /> : 'Yakin'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default KonfirmasiBatalBid;